const book =[
    {
        id: 1,
        img: "image/network/book.svg",
        book: 'https://drive.google.com/file/d/14pyKWJafKvd7dRhfaYDS18WRHWwWLpR5/view?usp=sharing'
    }
]

export default book